import { useQuery } from 'react-query';

import { getClientsOnMap } from 'api/clients/getClientsOnMap';

export const useGetClientsOnMap = () => {
  const { data, refetch, isLoading, isRefetching } = useQuery(['clientsOnMap'], () => getClientsOnMap(), {
    refetchOnWindowFocus: false,
  });

  return { data, refetch, isLoading, isRefetching };
};

export default useGetClientsOnMap;
